import React from 'react';
import { useSelector } from 'react-redux';
import {
    Navigate,
    useLocation,
} from 'react-router-dom';
import { Box } from '@mui/material';

import { useAuth } from "../../common/hooks/useAuth";

import { selectAllowNavigationFromLogin } from '../../common/store/locationsSlice';
import LanguageSwitcher from '../../common/ui/qvshop/components/LanguageSwitcher';

export const PublicRoute = ({ children }) => {
    const { token } = useAuth();
    const location = useLocation();

    const allowNavigationFromLogin = useSelector(selectAllowNavigationFromLogin);

    if (token && allowNavigationFromLogin) {
        const origin = location.state?.from?.pathname || "/items/";
        return <Navigate to={origin} replace state={{ from: location }} />
    }

    return (
        <>
            <Box sx={{ position: 'absolute', top: 16, right: 16, zIndex: 1 }}>
                <LanguageSwitcher />
            </Box>
            {children}
        </>
    );
};